import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'button-chip-section',
  templateUrl: './button-chip-section.component.html',
  styleUrls: ['./button-chip-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ButtonChipSectionComponent {
  @Input() public name: string;
  @Input() public buttonChips: any[] = [];
  @Input() isMobile;

  @Output() public buttonChipToggled = new EventEmitter<any>();
}
